let map, marker, form, selects;
let usernameAvailable = false;

$(document).ready(function() {
    form = $('#vendorSignupForm');

    function isSignupOrganisationOnly() {
        return typeof window.signupOrganisationOnly !== 'undefined' && window.signupOrganisationOnly === true;
    }

    function applyOrganisationOnlyUi() {
        if (!isSignupOrganisationOnly()) {
            return;
        }
        $('.signup-account-tab').addClass('d-none');
        $('.signup-account-step').addClass('d-none');
        $('.signup-step3-next').addClass('d-none');
        $('#submitBtnOrgOnly').removeClass('d-none');
        if (isBuyerMode()) {
            $('#submitBtnOrgOnly').text('Create buyer organisation');
        } else {
            $('#submitBtnOrgOnly').text('Create vendor organisation');
        }
        usernameAvailable = true;
    }

    function getAccountType() {
        const $el = $('#accountType');
        if (!$el.length) {
            return '';
        }
        return String($el.val() || '').toLowerCase();
    }

    function isBuyerMode() {
        return getAccountType() === 'buyer';
    }

    function isVendorMode() {
        return getAccountType() === 'vendor';
    }

    function applyAccountMode() {
        const buyer = isBuyerMode();
        const vendor = isVendorMode();
        const ready = buyer || vendor;

        $('.steps-nav').toggleClass('d-none', !ready);
        if (!ready) {
            $('.step').addClass('d-none');
            return;
        }

        $('.step-tab-membership').toggleClass('d-none', buyer);
        $('.step[data-step="1"]').toggleClass('d-none', buyer);
        $('#buyerProfileTypeRow').toggleClass('d-none', !buyer);

        if (buyer) {
            const t = $('#buyerProfileType').val() || 'individual';
            applyMembershipRules(t);
            showStep(2);
            $('#submitBtn').text('Create buyer account');
        } else {
            showStep(1);
            $('#submitBtn').text('Register vendor account');
            const groupId = $('#membershipGroup').val();
            if (groupId && membershipGroups.length) {
                const selectedGroup = membershipGroups.find(function (g) {
                    return String(g.id) === String(groupId);
                });
                if (selectedGroup) {
                    applyMembershipRules(selectedGroup.name.toLowerCase());
                }
            }
            const $membershipGroupSelect = $('#membershipGroup');
            if (selects && selects.membershipGroup && $membershipGroupSelect.prop('disabled') && membershipGroups.length > 0) {
                const gid = String(membershipGroups[0].id);
                selects.membershipGroup.setSelected(gid);
                const filteredTypes = membershipTypes
                    .filter(function (item) {
                        return item.group_id == gid;
                    })
                    .map(function (item) {
                        return { text: item.name, value: item.id };
                    });
                selects.membershipType.setData([
                    { text: 'Select Membership Type', value: '' }
                ].concat(filteredTypes));
                applyMembershipRules('corporate');
            }
        }

        applyOrganisationOnlyUi();
    }

    $.validator.addMethod('pwcheck', function(value) {
        return PasswordHelper.checkRequirements(value).valid;
    });

    $.validator.addMethod("usernameFormat", function(value, element) {
        return this.optional(element) || UsernameHelper.isValid(value);
    }, "Invalid username format");

    $.validator.addMethod('nameCheck', function (value) {
        return NameHelper.isValid(value);
    }, "Please enter a valid name");

    $.validator.addMethod('accountTypeRequired', function (value) {
        if ($('#accountTypeRow').hasClass('account-type-locked')) {
            return true;
        }
        return value === 'buyer' || value === 'vendor';
    }, 'Please choose buyer or vendor');

    form.validate({
        ignore: ":hidden:not(select):not(#accountType)",
        errorPlacement: function(error, element) {
            if (element.attr('id') === 'accountType') {
                error.insertAfter('#accountTypeRow');
                return;
            }

            if (element.closest('.input-group').length) {
                error.insertAfter(element.closest('.input-group'));
                return;
            }

            if (element.is('select')) {
                error.insertAfter(element.next('.ss-main'));
                return;
            }

            error.insertAfter(element);
        },
        rules: {
            accountType: {
                accountTypeRequired: true
            },
            membershipGroup: {
                required: {
                    depends: function () {
                        return isVendorMode();
                    }
                }
            },
            membershipType: {
                required: {
                    depends: function () {
                        return isVendorMode();
                    }
                }
            },
            username: {
                required: true,
                usernameFormat: true
            },
            firstName: { required: true, nameCheck: true },
            lastName: { required: true, nameCheck: true },
            corporateFirstName: { required: true, nameCheck: true },
            corporateLastName: { required: true, nameCheck: true },
            businessName: {
                required: {
                    depends: function () {
                        return !$('#corporateSection').hasClass('d-none');
                    }
                },
                nameCheck: true
            },
            registrationNumber: {
                required: {
                    depends: function () {
                        return !$('#corporateSection').hasClass('d-none');
                    }
                }
            },
            vatNumber: {
                required: {
                    depends: function () {
                        return !$('#corporateSection').hasClass('d-none');
                    }
                }
            },
            phoneNumber: { required: true },
            email: { required: true, email: true },
            password: { required: true, minlength: 8, pwcheck: true },
            confirmPassword: { required: true, equalTo: '#password' },
            occupationIdIndividual: { required: true },
            occupationIdCorporate: { required: true },
            locationCountry: { required: true },
            locationRegion: { required: true },
            locationDistrict: { required: true },
            locationAreaName: { required: true },
            locationVillage: { required: true }
        },
        messages: {
            password: {
                required: "Please enter a password",
                minlength: "Password must be at least 8 characters",
                pwcheck: "Password must include an uppercase letter and a symbol"
            },
            confirmPassword: {
                required: "Please confirm your password",
                equalTo: "Passwords do not match"
            },
            username: {
                usernameFormat: "Username must be 3-32 characters and use letters, numbers, . or _"
            },
            occupationIdIndividual: {
                required: "Please select your occupation"
            },
            occupationIdCorporate: {
                required: "Please select your occupation"
            },
            accountType: {
                accountTypeRequired: "Please choose buyer or vendor"
            }
        }
    });

    $(document).on('click', '.account-type-card:not(:disabled)', function () {
        const t = $(this).attr('data-account-type');
        if (!t) {
            return;
        }
        $('#accountType').val(t);
        $('#accountTypeRow .account-type-card').removeClass('account-type-card--selected account-type-card--dim');
        $(this).addClass('account-type-card--selected');
        form.validate().element('#accountType');
        applyAccountMode();
    });

    function runSignupSubmit(button) {
        const turnstileToken = $('[name="cf-turnstile-response"]').val();
        if ($('[data-sitekey]').length && (!turnstileToken || turnstileToken.trim() === '')) {
            notify('error', 'Please complete the verification challenge');
            return;
        }

        const formValues = form.serializeArray();
        const output = {};

        formValues.forEach(function (item) {
            output[item.name] = item.value;
        });

        output.isCorporate = !$('#corporateSection').hasClass('d-none');
        output.occupationId = output.isCorporate ? (output.occupationIdCorporate || '') : (output.occupationIdIndividual || '');
        output.accountType = isBuyerMode() ? 'buyer' : 'vendor';
        if (isBuyerMode()) {
            delete output.membershipGroup;
            delete output.membershipType;
        }
        if (turnstileToken) {
            output.turnstile_token = turnstileToken;
        }
        if (isSignupOrganisationOnly()) {
            output.organisation_only = true;
        }

        btnLoader.start(button, 'Submitting...');

        $.ajax({
            url: '/api/vendors/register',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(output),
            xhrFields: { withCredentials: true },
            success: function(response) {
                btnLoader.stop(button);

                if (response.success) {
                    if (isSignupOrganisationOnly()) {
                        notify('success', isBuyerMode() ? 'Buyer organisation created.' : 'Vendor organisation created.');
                    } else {
                        notify('success', isBuyerMode() ? 'Buyer account created successfully!' : 'Vendor created successfully!');
                    }

                    let nextUrl = '/dashboard';
                    const r = response.redirect;
                    if (typeof r === 'string' && r.startsWith('/') && !r.startsWith('//')) {
                        nextUrl = r;
                    }

                    setTimeout(function () {
                        window.location.href = nextUrl;
                    }, 800);
                } else {
                    resetTurnstile();
                    notify('error', response.message || 'Something went wrong');
                }
            },
            error: function(xhr) {
                btnLoader.stop(button);
                resetTurnstile();
                let msg = 'Could not complete signup. Please try again.';
                try {
                    const data = JSON.parse(xhr.responseText);
                    if (data.message) {
                        msg = data.message;
                    }
                } catch (err) {}
                notify('error', msg);
                console.error('API Error:', xhr.responseText);
            }
        });
    }

    $('#submitBtn').on('click', function (e) {
        e.preventDefault();

        if (!validateStep(this)) {
            return;
        }

        if (!isSignupOrganisationOnly() && !usernameAvailable) {
            $('#usernameFeedback').html(
                '<span class="text-danger"><i class="fa-solid fa-circle-xmark me-1"></i>Please check the username before submitting</span>'
            );
            return;
        }

        runSignupSubmit($(this));
    });

    $('#submitBtnOrgOnly').on('click', function (e) {
        e.preventDefault();
        if (!form.valid()) {
            return;
        }
        runSignupSubmit($(this));
    });

    $('#membershipGroup').on('change', function () {
        if (isBuyerMode()) {
            return;
        }

        const groupId = $(this).val();

        const filteredTypes = membershipTypes
            .filter(item => item.group_id == groupId)
            .map(item => ({
                text: item.name,
                value: item.id
            }));

        selects.membershipType.setData([
            { text: 'Select Membership Type', value: '' },
            ...filteredTypes
        ]);

        selects.membershipType.setSelected('');

        const selectedGroup = membershipGroups.find(g => g.id == groupId);
        if (!selectedGroup) return;

        const typeKey = selectedGroup.name.toLowerCase();
        applyMembershipRules(typeKey);
    });

    $('#username').on('input', function () {
        usernameAvailable = false;
        $('#usernameFeedback').empty();
        $('#usernameSuggestions').hide();
    });

    const VENDOR_PASSWORD_RULE_IDS = ['ruleLength', 'ruleUppercase', 'ruleSymbol'];

    $('#password').on('input', function() {
        const password = $(this).val();
        $('#passwordHelper').show();
        const req = PasswordHelper.checkRequirements(password);
        PasswordHelper.applyRuleIcons(VENDOR_PASSWORD_RULE_IDS, req);
    });

    $('#confirmPassword').on('input', function() {
        const match = this.value === $('#password').val();
        this.setCustomValidity(match ? '' : 'Passwords do not match');
    });

    $('#governmentSelect').on('change', function () {
        const selectedCountry = $(this).val();
        const regionSelect = $('#councilSelect');
        const wardSelect = $('#wardSelect');

        regionSelect.html('<option value="">Select Region</option>');
        wardSelect.html('<option value="">Select District/Area</option>');

        Object.keys(regionData[selectedCountry].regions).forEach(function (regionName) {
            regionSelect.append(`<option value="${regionName}">${regionName}</option>`);
        });
    });

    $('#detectLocationBtn').on('click', function () {
        if (!navigator.geolocation) {
            notify('error', 'Location detection is not supported in this browser.');
            return;
        }

        initMap();

        const geoOptions = {
            enableHighAccuracy: true,
            timeout: 20000,
            maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(function (pos) {
            const userLat = pos.coords.latitude.toFixed(6);
            const userLng = pos.coords.longitude.toFixed(6);

            $('#latitude').val(userLat);
            $('#longitude').val(userLng);

            if (marker) {
                map.removeLayer(marker);
            }

            marker = L.marker([userLat, userLng]).addTo(map);
            map.setView([userLat, userLng], 15);
            setTimeout(function () {
                map.invalidateSize();
            }, 100);

            fetchLocationDetails(userLat, userLng);
        }, function (err) {
            let msg = 'Unable to detect your location. Allow location access for this site or place the pin on the map.';

            if (err && err.code === 1) {
                msg = 'Location access was denied. Allow location for this site in your browser settings, or place the pin on the map.';
            } else if (err && err.code === 2) {
                msg = 'Your position could not be determined. Try again or place the pin on the map.';
            } else if (err && err.code === 3) {
                msg = 'Location request timed out. Try again or place the pin on the map.';
            }

            notify('error', msg);
        }, geoOptions);
    });

    $('#checkUsernameBtn').on('click', async function () {
        const username = $('#username').val().trim();

        if (!UsernameHelper.isValid(username)) {
            $('#usernameFeedback').html(
                '<span class="text-danger"><i class="fa-solid fa-circle-xmark me-1"></i>Invalid username format</span>'
            );
            return;
        }

        const isAvailable = await checkUsernameAvailability(username);

        if (isAvailable) {
            setUsername(username);
        } else {
            $('#usernameFeedback').html(
                '<span class="text-danger"><i class="fa-solid fa-circle-xmark me-1"></i>Username is taken</span>'
            );

            autoGenerateUsername(false);
        }
    });

    $('.step-tab').on('click', function() {
        const targetStep = parseInt($(this).data('step'), 10);
        if (isBuyerMode() && targetStep === 1) {
            return;
        }
        validateStep(this);
    });

    $('.next-step').on('click', function() {
        validateStep(this);
    });

    $('#locationCountry').on('change', function () {
        if (!map) {
            return;
        }

        const val = $(this).val();

        const centres = {
            'Uganda': [1.3733, 32.2903],
            'Kenya': [0.0236, 37.9062],
            'United Kingdom': [54.0000, -2.0000]
        };

        if (centres[val]) {
            map.setView(centres[val], 7);
        }
    });

    $('#phoneNumber').on('input', function () {
        const cleaned = this.value
            .replace(/\s+/g, '')
            .replace(/^0+/, '');

        this.value = cleaned;

        const code = $('#phoneCountry').val();
        const number = this.value.trim();

        if (!PhoneHelper.regex[code]) return;

        if (PhoneHelper.isValid(code, number)) {
            $('#phoneFeedback').html(
                '<span class="text-success"><i class="fa fa-check me-1"></i> Valid phone number</span>'
            );
        } else {
            $('#phoneFeedback').html(
                '<span class="text-danger"><i class="fa-solid fa-circle-xmark me-1"></i> Invalid phone number</span>'
            );
        }
    });

    selects = {
        membershipGroup: new SlimSelect({ select: '#membershipGroup' }),
        membershipType: new SlimSelect({ select: '#membershipType' }),
        locationCountry: new SlimSelect({ select: '#locationCountry' }),
        phoneCountry: new SlimSelect({ select: '#phoneCountry' }),
        title: new SlimSelect({ select: 'select[name="title"]' }),
        gender: new SlimSelect({ select: 'select[name="gender"]' }),
        corporateTitle: new SlimSelect({ select: 'select[name="corporateTitle"]' }),
        corporateGender: new SlimSelect({ select: 'select[name="corporateGender"]' }),
        occupationIdIndividual: new SlimSelect({ select: '#occupationIdIndividual' }),
        occupationIdCorporate: new SlimSelect({ select: '#occupationIdCorporate' }),
        buyerProfileType: new SlimSelect({
            select: '#buyerProfileType',
            events: {
                afterChange: function () {
                    if (!isBuyerMode()) {
                        return;
                    }
                    applyMembershipRules($('#buyerProfileType').val());
                }
            }
        })
    };

    if ($('#accountType').is('select')) {
        selects.accountType = new SlimSelect({
            select: '#accountType',
            placeholder: 'Select account type',
            events: {
                afterChange: function () {
                    applyAccountMode();
                }
            }
        });
    }

    if (window.signupPrefill) {
        const p = window.signupPrefill;
        $('input[name="firstName"]').val(p.firstName || '');
        $('input[name="lastName"]').val(p.lastName || '');
        $('input[name="corporateFirstName"]').val(p.firstName || '');
        $('input[name="corporateLastName"]').val(p.lastName || '');
        if (p.title) {
            $('select[name="title"]').val(p.title);
            if (selects.title) {
                selects.title.setSelected(p.title);
            }
            $('select[name="corporateTitle"]').val(p.title);
            if (selects.corporateTitle) {
                selects.corporateTitle.setSelected(p.title);
            }
        }
        if (p.gender) {
            $('select[name="gender"]').val(p.gender);
            if (selects.gender) {
                selects.gender.setSelected(p.gender);
            }
            $('select[name="corporateGender"]').val(p.gender);
            if (selects.corporateGender) {
                selects.corporateGender.setSelected(p.gender);
            }
        }
        if (p.occupation_id && p.occupation_id > 0) {
            const oid = String(p.occupation_id);
            $('#occupationIdIndividual').val(oid);
            $('#occupationIdCorporate').val(oid);
            if (selects.occupationIdIndividual) {
                selects.occupationIdIndividual.setSelected(oid);
            }
            if (selects.occupationIdCorporate) {
                selects.occupationIdCorporate.setSelected(oid);
            }
        }
        if (p.phoneCountry) {
            $('#phoneCountry').val(p.phoneCountry);
            if (selects.phoneCountry) {
                selects.phoneCountry.setSelected(p.phoneCountry);
            }
        }
        if (p.phoneNumber) {
            $('#phoneNumber').val(p.phoneNumber);
        }
    }

    applyAccountMode();
});

async function fetchLocationDetails(lat, lng) {
  $('.location-loader').removeClass('d-none');

  const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;

  const response = await fetch(url, {
    headers: { 'User-Agent': 'AwegaPlus-Location-Lookup' }
  });

  const data = await response.json();
  const a = data.address || {};

  selects.locationCountry.setSelected(a.country || '');

  $('#locationRegion').val(a.county || a.state || a.region || '');
  $('#locationDistrict').val(a.state_district || a.municipality || a.city_district || '');
  $('#locationAreaName').val(a.suburb || a.township || a.ward || '');
  $('#locationVillage').val(a.village || a.hamlet || a.locality || '');

  $('.location-loader').addClass('d-none');
}

function resetTurnstile() {
    try {
        if (typeof turnstile !== 'undefined' && typeof turnstile.reset === 'function') {
            turnstile.reset();
        }
    } catch (e) {}
}

function showUsernameSuggestions(list) {
    const container = $('#usernameSuggestions');
    container.show();

    let html = `<div class="p-2 border rounded"><div class="d-flex flex-wrap gap-2">`;

    list.forEach(name => {
        html += `
            <span class="badge bg-primary p-2 username-suggestion" data-username="${name}" style="cursor:pointer;">
                ${name}
            </span>`;
    });

    html += `</div></div>`;
    container.html(html);

    $('.username-suggestion').on('click', function () {
        const name = $(this).data('username');
        setUsername(name);
    });
}

function generateUsernameList(first, last) {
    first = first.toLowerCase().replace(/[^a-z]/g, '');
    last = last.toLowerCase().replace(/[^a-z]/g, '');

    const base = [
        `${first}${last}`,
        `${first}.${last}`,
        `${first}_${last}`,
        `${first}${last}123`,
        `${first}.${last}123`,
        `${first}_${last}254`,
        `${first}${last}${Math.floor(Math.random()*999)}`,
        `${first.charAt(0)}.${last}`,
        `${first.charAt(0)}${last}`
    ];

    return base.filter(u => UsernameHelper.isValid(u));
}

function generateRandomUsernames() {
    const firstName = $('input[name="firstName"]').val().trim();
    const lastName = $('input[name="lastName"]').val().trim();
    const candidates = generateUsernameList(firstName, lastName);

    showUsernameSuggestions(candidates.slice(0, 5));

    $('#usernameFeedback').html(
        '<span class="text-danger"><i class="fa-solid fa-circle-xmark me-1"></i>Username not available. Try a suggestion.</span>'
    );
}

async function checkUsernameAvailability(username) {
    const res = await fetch('/api/auth/checkUsername', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username })
    });

    const data = await res.json();
    return data.available === true;
}

async function autoGenerateUsername(autoSet = false) {
    let base = "";
    
    const isCorporate = !$('#corporateSection').hasClass('d-none');

    if (isCorporate) {
        const first = $('input[name="corporateFirstName"]').val().trim();
        const last = $('input[name="corporateLastName"]').val().trim();
        base = `${first}${last}`.trim();
    } else {
        const first = $('input[name="firstName"]').val().trim();
        const last = $('input[name="lastName"]').val().trim();
        base = `${first}${last}`.trim();
    }

    base = base.toLowerCase().replace(/[^a-z0-9]/g, '').substring(0, 20);

    if (!base) {
        return generateFallbackSuggestions();
    }

    const candidates = [
        base,
        base + Math.floor(Math.random() * 99),
        base + Math.floor(Math.random() * 99),
        base + Math.floor(Math.random() * 99)
    ].filter(u => UsernameHelper.isValid(u));

    if (autoSet == true) {
        for (const name of candidates) {
            if (await checkUsernameAvailability(name)) {
                setUsername(name);
                return;
            }
        }
    }

    $('#usernameFeedback').html(
        '<span class="text-danger"><i class="fa-solid fa-circle-xmark me-1"></i>Username not available. Try a suggestion.</span>'
    );

    showUsernameSuggestions(candidates.slice(0, 5));
}

function generateFallbackSuggestions() {
    const randoms = [];
    for (let i = 0; i < 5; i++) {
        const name = "user" + Math.floor(Math.random() * 999999);
        if (UsernameHelper.isValid(name)) randoms.push(name);
    }
    showUsernameSuggestions(randoms);
}

function setUsername(name) {
    $('#username').val(name);
    $('#usernameFeedback').html(
        '<span class="text-success"><i class="fa fa-check me-1"></i>Username is available</span>'
    );
    $('#usernameSuggestions').hide();
    usernameAvailable = true;
}

function validateStep(trigger) {
    const targetStep = parseInt($(trigger).data('step'));
    const currentStep = parseInt($('.step-tab.active').data('step'));

    if (targetStep < currentStep) {
        showStep(targetStep);
        return;
    }

    if (targetStep > currentStep && $('#accountType').length && !$('#accountTypeRow').hasClass('account-type-locked')) {
        if (!form.validate().element('#accountType')) {
            return false;
        }
    }

    const step = $('.step[data-step="' + currentStep + '"]');
    const inputs = step.find('input:visible, select:visible').not(':disabled');

    let isValid = true;

    inputs.each(function () {
        if (!form.validate().element(this)) {
            isValid = false;
        }
    });

    if (!isValid) return false;

    showStep(currentStep + 1);
    return true;
}

function applyMembershipRules(type) {
    const membershipRequirements = {
        individual: {
            show: '#individualSection',
            hide: '#corporateSection',
            required: ['firstName', 'lastName'],
            optional: [
                'businessName',
                'corporateFirstName',
                'corporateLastName',
                'registrationNumber',
                'vatNumber'
            ]
        },
        corporate: {
            show: '#corporateSection',
            hide: '#individualSection',
            required: [
                'businessName',
                'corporateFirstName',
                'corporateLastName',
                'registrationNumber',
                'vatNumber'
            ],
            optional: ['firstName', 'lastName']
        }
    };

    const config = membershipRequirements[type];
    if (!config) return;

    $(config.show).removeClass('d-none');
    $(config.hide).addClass('d-none');

    config.required.forEach(name => {
        $(`input[name="${name}"]`).attr('required', true);
    });

    config.optional.forEach(name => {
        $(`input[name="${name}"]`).removeAttr('required');
    });
}

function initMap() {
    if (map) return;

    map = L.map('locationMap').setView([1.3733, 32.2903], 8);

    map.on('click', function(e) {
        const lat = e.latlng.lat.toFixed(6);
        const lng = e.latlng.lng.toFixed(6);

        $('#latitude').val(lat);
        $('#longitude').val(lng);

        if (marker) map.removeLayer(marker);
        marker = L.marker([lat, lng]).addTo(map);

        fetchLocationDetails(lat, lng);
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);

    setTimeout(() => map.invalidateSize(), 300);
}

function showStep(step) {
    const maxStep = $('.step').length; 
    if (step > maxStep) return;

    $('.step').addClass('d-none');
    $('.step[data-step="' + step + '"]').removeClass('d-none');

    $('.step-tab').removeClass('active');
    $('.step-tab[data-step="' + step + '"]').addClass('active');

    if (step === 3) {
        initMap();

        if (map) {
            setTimeout(function () {
                map.invalidateSize();
            }, 200);
        }

        const orgOnly = typeof window.signupOrganisationOnly !== 'undefined' && window.signupOrganisationOnly === true;
        if (!orgOnly) {
            autoGenerateUsername(true);
        }
    }
}